import React from 'react';
import classNames from 'clsx';

import { useStyles } from './CalculationFirstStepPlaceholderContent.styles';

export default function CalculationFirstStepPlaceholderContent() {
  const classes = useStyles();

  const renderConsentRow = (rowClassName: string, lineCount: number) => (
    <div className={classNames(classes.consentRow, rowClassName)}>
      <div className={classes.checkbox} />
      <div className={classes.consentLines}>
        {Array.from({ length: lineCount }).map((_, lineIndex) => (
          <div
            className={classNames(classes.consentLine, {
              [classes.consentLineLast]: lineIndex === lineCount - 1,
            })}
            key={lineIndex}
          />
        ))}
      </div>
    </div>
  );

  return (
    <div className={classes.root}>
      <div className={classNames(classes.field, classes.registrationNumber)} />
      <div className={classes.successMessage} />
      <div
        className={classNames(
          classes.checkboxRow,
          classes.registrationNumberNotKnown
        )}
      >
        <div className={classes.checkbox} />
        <div className={classes.checkboxLabel} />
      </div>
      <div className={classNames(classes.field, classes.ownerBirthDate)} />
      <div
        className={classNames(classes.checkboxRow, classes.acceptAllConsents)}
      >
        <div className={classes.checkbox} />
        <div className={classes.acceptAllLabel} />
      </div>
      <div className={classes.consents}>
        {renderConsentRow(classes.consentRowRegulations, 1)}
        {renderConsentRow(classes.consentRowCepik, 2)}
        {renderConsentRow(classes.consentRowMarketing, 3)}
      </div>
      <div className={classes.submitButton} />
    </div>
  );
}
